
import {map} from 'rxjs/operators';
import {Component, Injectable} from '@angular/core';
import {CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from './ComponentCanDeactivate';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UnsavedChangesMessageComponent } from './unsaved-changes-message/unsaved-changes-message.component';

import {SharedService} from '../../shared.service';

/**
 * This guard is meant to show an unsaved changes warning when the user navigates away from a page.
 *
 * To use this guard, do the following:
 * 1. Implement ComponentCanDeactivate on your component
 * 2. Register this guard in the CanDeactivate parameter of your route.
 *
 * This guard will call the canDeactivate function of your component.
 * If the function returns, true, it will simply continue with the route.
 * If the function returns false, it will show an unsaved changes warning.
 *
 * NOTE: THIS IS DEPRECIATED. USE THE CHECK FOR ERRORS GUARD.
 */
@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

    // Instance Properties
    warningDialog: MatDialogRef<UnsavedChangesMessageComponent>;
    currentComponent: Component;

    // Class Functions
    constructor(
        private dialog: MatDialog,
        private sharedService: SharedService
    ) { }

    // Methods
    checkForDeactivation (): Observable<boolean> | Promise<boolean> | boolean {
		// POST: checks the router state tree for itself and, if it's there, performs canDeactivate
		if (this.sharedService.currentComponent && this.sharedService.currentComponent.canDeactivate != undefined) {
		    return this.canDeactivate(this.sharedService.currentComponent);
        } else {
		    return true;
        }
	}

	canDeactivate (component: ComponentCanDeactivate, currentRoute?: ActivatedRouteSnapshot, currentState?: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // PRE: a component that implements ComponentCanDeactivate
        // POST: If the component allows, transitions. If not, shows a warning dialog.
        return component.canDeactivate () ? true : this.showWarning ();
    }

    showWarning () {
        // POST: shows a warning dialog. If the user clicks OK, returns true. Else, returns false.
        this.warningDialog = this.dialog.open(UnsavedChangesMessageComponent, {
            disableClose: true
        });
        this.warningDialog.componentInstance.dialogBox = this.warningDialog;
        return this.warningDialog.componentInstance.stayEvent.pipe(map(result => {
            return result;
        }));
    }
}
